let instance = null;

export const setLenis = (l) => { instance = l; };

export const scrollToTarget = (target, opts = {}) => {
  if (instance) { instance.scrollTo(target, { offset: -90, ...opts }); return; }
  if (typeof target === "number") window.scrollTo(0, target);
  else document.querySelector(target)?.scrollIntoView();
};

export const stopScroll = () => instance?.stop();
export const startScroll = () => instance?.start();
